export const CONTRACT_SIGNING_PROGRESS_POLL_INTERVAL = 5000;
